export default {_name:'Text.StatusChip',module:'Field',view:'Element/Text/StatusChip',webOptions:{md:8},mobileOptions:{ms:8}}